import { ComponentsType } from "api/cms-website/cms-website.types";

/**
 * Maps GraphQL __typename to ComponentsType enum values
 */
export const typenameToComponentMap: Record<string, ComponentsType> = {
    ComponentComponentsAwards: ComponentsType.AWARDS,
    ComponentComponentsBannerPaidSocial: ComponentsType.BANNER_PAID_SOCIAL,
    ComponentComponentsClinicsList: ComponentsType.CLINICS_LIST,
    ComponentComponentsClinicsMap: ComponentsType.CLINICS_MAP,
    ComponentComponentsMainBanner: ComponentsType.MAIN_BANNER,
    ComponentComponentsMainBannerHeader: ComponentsType.MAIN_BANNER_HEADER,
    ComponentComponentsMainBannerExtra: ComponentsType.MAIN_BANNER_EXTRA,
    ComponentComponentsTwoColumnList: ComponentsType.TWO_COLUMN_LIST,
    ComponentComponentsTextWithCta: ComponentsType.TEXT_WITH_CTA,
    ComponentComponentsTextWithCtaFiftyFifty:
        ComponentsType.TEXT_WITH_CTA_FIFTY_FIFTY,
    ComponentComponentsAdvantagesWithHeading:
        ComponentsType.ADVANTAGES_WITH_HEADING,
    ComponentComponentsMultiColumnSlider: ComponentsType.MULTI_COLUMN_SLIDER,
    ComponentComponentsMultiColumn: ComponentsType.MULTI_COLUMN,
    ComponentComponentsQuestionsWithImage: ComponentsType.QUESTIONS_WITH_IMAGE,
    ComponentComponentsSlider: ComponentsType.SLIDER,
    ComponentComponentsTabbedContent: ComponentsType.TABBED_CONTENT,
    ComponentComponentsTableWithCheckmarks:
        ComponentsType.TABLE_WITH_CHECKMARKS,
    ComponentComponentsMap: ComponentsType.MAP,
    ComponentComponentsQuestions: ComponentsType.QUESTIONS,
    ComponentComponentsLargePicture: ComponentsType.LARGE_PICTURE,
    ComponentComponentsPriceBlock: ComponentsType.PRICE_BLOCK,
    ComponentComponentsLeadForm: ComponentsType.LEAD_FORM,
    ComponentComponentsTreatmentInfo: ComponentsType.TREATMENT_INFO,
    ComponentComponentsVerticalAdvantages: ComponentsType.VERTICAL_ADVANTAGES,
    ComponentComponentsHalfTextAndImageBanner:
        ComponentsType.HALF_TEXT_AND_IMAGE_BANNER,
    ComponentComponentsVerticalListWithImage:
        ComponentsType.VERTICAL_LIST_WITH_IMAGE,
    ComponentComponentsVerticalListSection:
        ComponentsType.VERTICAL_LIST_SECTION,
    ComponentComponentsTreatmentIncludesSection:
        ComponentsType.TREATMENT_INCLUDES_SECTION,
    ComponentComponentsIllustratedList: ComponentsType.ILLUSTRATED_LIST,
    ComponentComponentsImageCardGrid: ComponentsType.IMAGE_CARD_GRID,
    ComponentComponentsInfoBanner: ComponentsType.INFO_BANNER,
    ComponentComponentsListWithCta: ComponentsType.LIST_WITH_CTA,
    ComponentComponentsFollowUs: ComponentsType.FOLLOW_US,
    ComponentComponentsVideo: ComponentsType.VIDEO,
    ComponentComponentsReferralBanner: ComponentsType.REFERRAL_BANNER,
    ComponentComponentsReferralHero: ComponentsType.REFERRAL_HERO,
    ComponentComponentsTermLink: ComponentsType.TERM_LINK,
};

/**
 * Converts GraphQL component with __typename to frontend component with __component
 */
export function mapComponentTypename(component: any): any {
    if (!component || typeof component !== "object") {
        return component;
    }

    const typename = component.__typename;
    if (!typename) {
        return component;
    }

    const componentType = typenameToComponentMap[typename];
    if (!componentType) {
        return component;
    }

    // Remove __typename and add __component
    const { __typename, ...rest } = component;
    return {
        ...rest,
        __component: componentType,
    };
}
